<div ngbDropdown #dropdownRef="ngbDropdown" placement="bottom-left" class="form-floating" (openChange)="onDropdownOpenChange($event)">
  @if (isInputDropdown()) {
    <input
      #inputRef
      ngbDropdownToggle
      type="text"
      role="combobox"
      autocomplete="off"
      aria-haspopup="listbox"
      class="form-control text-start text-truncate"
      [id]="inputId()"
      [value]="inputValue() | translate"
      [disabled]="disabled()"
      [attr.data-test]="dataTestAttribute()?.page + '-input-trigger' + dataTestAttribute()?.scope + 'Dropdown'"
      [attr.aria-expanded]="dropdownRef.isOpen()"
      (focus)="onFocus()"
      (blur)="onBlur()"
      (input)="onInput($event)"
      (keydown)="handleTabNavigation($event)"
    />
  } @else {
    <button
      #buttonRef
      ngbDropdownToggle
      type="button"
      class="form-control text-start text-truncate"
      [disabled]="disabled()"
      [attr.data-test]="dataTestAttribute()?.page + '-button-trigger' + dataTestAttribute()?.scope + 'Dropdown'"
      (keydown)="handleTabNavigation($event)"
    >
      {{ selectedOption()?.text | translate }}
    </button>
  }

  <label [for]="inputId()"> {{ labelKey() | translate }} </label>
  <i
    aria-hidden="true"
    class="form-floating-icon chevron fa-solid d-flex pe-none"
    [ngClass]="{ 'fa-chevron-up': dropdownRef.isOpen(), 'fa-chevron-down': !dropdownRef.isOpen() }"
  ></i>
  <div
    ngbDropdownMenu
    class="dropdown-menu"
    [ngClass]="customDropdownMenuClass() || 'dropdown-menu-default'"
    role="listbox"
    [attr.data-test]="dataTestAttribute()?.page + '-list-' + dataTestAttribute()?.scope + 'DropdownMenu'"
  >
    @for (option of optionsList(); track option.text) {
      <button
        ngbDropdownItem
        type="button"
        role="option"
        tabindex="-1"
        [attr.aria-selected]="selectedOption()?.value === option.value"
        [attr.data-test]="dataTestAttribute()?.page + '-button-selectOption' + option.text | translate | libIKPEscapeText"
        (click)="selectOption(option)"
      >
        @if (optionTemplate() && option !== ALL_OPTION) {
          <ng-container *ngTemplateOutlet="optionTemplate()!; context: { $implicit: option }" />
        } @else {
          {{ option.text | translate }}
        }
      </button>
    }
  </div>
</div>
